export const LIVE_CLASS_LIST_REQ = "LIVE_CLASS_LIST_REQ";
export const LIVE_CLASS_LIST_SUCCESS = "LIVE_CLASS_LIST_SUCCESS";
export const LIVE_CLASS_LIST_FAILED = "LIVE_CLASS_LIST_FAILED";
